<template>
  
  <div id="quotation-customer" class="sixteen wide column">

    <div class="ui segment" :class="{ loading }">
      <h4 class="ui dividing header">Cliente</h4>
      <form class="ui form">
        <div class="fields">
          <div class="four wide field" :class="{ disabled: !canChangeCustomer }">
            <label class="form-label">Código <span class="red text">*</span></label>
            <div class="ui action input">
              <input v-if="canChangeCustomer" type="text" maxlength="6" v-model="customerCode" @blur="onBlurCustomerCode()">
              <input v-else type="text" maxlength="6" :value="customerCode" readonly="readonly" >
              <button type="button" class="ui basic icon button" @click="$refs.customerPicker.show()">
                <i class="search plus black icon"></i>
              </button>
            </div>            
          </div>          
          <div class="two wide field" :class="{ disabled: !canChangeCustomer }">
            <label class="form-label">Loja <span class="red text">*</span></label>
            <input v-if="canChangeCustomer" type="text" maxlength="2" v-model="customerUnit" @blur="onBlurCustomerUnit()">
            <input v-else type="text" :value="customerUnit" readonly="readonly">
          </div>  
          <div class="ten wide field">
            <label class="form-label">Razão Social</label>
            <input type="text" readonly="readonly" :value="customer.name">
          </div>
        </div>
        
        <div class="fields">  
          <div class="four wide field" :class="{ disabled: !canChangeCustomer }">
            <label class="form-label">CNPJ 
              <span v-show="!lcnpjReadyOnly" class="red text">*</span>
            </label>
            <input type="text" 
              :readonly="lcnpjReadyOnly" 
              v-model="quotation.CnpjPadrao"  
              @blur="onChangeCNPJ()">
          </div>
          <div class="three wide field">
            <label class="form-label">Inscrição Estadual</label>
            <input type="text" readonly="readonly" :value="customer.ie">
          </div>
          <div class="nine wide field">
            <label class="form-label">Endereço</label>
            <input type="text" readonly="readonly" :value="customerAddress">
          </div>
        </div>
        
        <div v-show="customerCode == '000000' && customerUnit=='00' " class="fields">
          <div class="sixteen wide field" :class="{ disabled: !canChangeCustomer }">
            <label class="form-label">Suspect Info</label>
            <input type="text" readonly="readonly" v-model="cnpjInfo">
          </div>    
        </div>  
        
        <div class="fields">          
          <div class="four wide field">
            <label class="form-label">Telefone</label>
            <input type="text" readonly="readonly" :value="customer.phone ? customer.ddd + ' ' + customer.phone : ''">
          </div>
          <div class="nine wide field">
            <label class="form-label">E-mail</label>
            <input type="text" readonly="readonly" :value="customer.email">
          </div>
          <div class="three wide field" :class="{ disabled: (!(canChangeCustomer && canChangeRetail)) }">
            <label class="form-label">Venda Varejo <span class="red text">*</span></label>            
            <select id="select-retail" class="ui fluid dropdown" v-model="retail" readonly="readonly">
              <option value="">Selecione...</option>
              <option value="N">Não</option>
              <option value="S">Sim</option>
            </select>
          </div>
        </div>
      </form>
    </div>

    <customer-picker ref="customerPicker" @onSelect="onPickCustomer" />

  </div>

</template>

<script>

  import CustomerPicker from "@/components/customer-picker.vue"
  import CustomerService from "@/services/customer-service"
  import CnpjBusca from "@/services/cnpj-busca-service"
  import Message from "@/utils/message"

  export default {

    data() {
      return {        
        lcnpjReadyOnly: true,
        loading: true,
        canChangeRetail: false,
        customerCode: "",
        customerUnit: "",
        retail: "N",
        customer: {},
        cnpjInfo: ""        
      }
    },
    
    props: ["quotation", "isCreating", "isUpdating", "productInputVisible"],

    watch: {

      "customer" () {
        this.onChange()
      },

      "retail" () {
        this.onChange()
      },  
    },

    components: {
      CustomerPicker,
    }, 

    computed: {

      customerAddress() {
        return CustomerService.customerAddress(this.customer)
      },

      canChangeCustomer() {
        return (!this.productInputVisible && this.quotation.items.length == 0)
      },
    },

    created() {
      if (this.isUpdating) {
        this.quotation.customer.cnpj = this.quotation.CnpjPadrao
        this.onSelectCustomer(this.quotation.customer, true)
        this.onChangeCNPJ()
      }  
    },

    mounted() {

      $("#select-retail").dropdown()
      
      if (this.isUpdating)
        $("#select-retail").dropdown("set selected", this.retail)

      setTimeout(() => this.loading = false, 1000)  
    },

    methods: {
      async buscaCnpj(cnpj) {
        let infoCnpj = {status:500 , data: ''}
        try {
          let resp = await CnpjBusca.getDados(cnpj.trim())    
          infoCnpj = {status:200, data: resp}
        } catch (error) {
          infoCnpj = {status: error.response.status, data: error.request.responseText}
        } finally {
          return infoCnpj
        } 
      },
      onPickCustomer(customer) {

        this.customerCode = customer.code
        this.customerUnit = customer.unit

        this.loadCustomer()
      },

      onBlurCustomerCode() {

        if (!this.customerCode) {
          this.customerUnit = ""
          this.customer = {}
          return
        }  

        if (!this.customerUnit)
          this.customerUnit = this.customerCode == "000000" ? "00" : "01"

        this.loadCustomer()
      },

      onBlurCustomerUnit() {

        if (this.customerCode && this.customerUnit)
          this.loadCustomer()
      },

      async loadCustomer() {

        this.loading = true

        try {
          const customer = await CustomerService.getByCode(this.customerCode, this.customerUnit)

          if (customer.isBlocked) {
            Message.info("Cliente bloqueado")
            this.wipeMyBut()

          } else {
            
            this.onSelectCustomer(customer)
          }

          this.loading = false          

        } catch (error) {

          this.loading = false
          this.wipeMyBut()
          this.$errorHandler(error)
        }
      },

      wipeMyBut() {
        this.customer = {}
        this.lcnpjReadyOnly = true   
        this.cnpjInfo = ''
        this.quotation.CnpjPadrao = ''
        this.onChange()
      },
      onSelectCustomer(customer, creating) {

        this.customerCode = customer.code
        this.customerUnit = customer.unit
        this.customer = this.$cloneObject(customer)
        
        if ( this.isCreating && this.customer.code === '000000' && this.customer.unit === '00' ) {
          this.lcnpjReadyOnly = false
        } else {
          this.lcnpjReadyOnly = true
        }  
        
        if (creating) {
          this.retail = this.quotation.isRetail ? "S" : "N"
          this.canChangeRetail = customer.isRetail
          return
        }

        if (customer.isRetail) {

          this.retail = "N"
          // this.canChangeRetail = true
          
          // $("#select-retail").dropdown("clear")

        } else {

          this.retail = "N"        
          this.canChangeRetail = false
          $("#select-retail").dropdown("set selected", "N")
        }  
      },

      async onChangeCNPJ () {
        this.quotation.CnpjPadrao   = this.quotation.CnpjPadrao.replace(/[^\d]/g, "")
        if (this.quotation.CnpjPadrao.trim() !== ''){
          this.loading       = true
          let retorno        = await this.buscaCnpj(this.quotation.CnpjPadrao)
          this.loading       = false
          this.cnpjInfo      = retorno.data
          if (retorno.status !== 200 ) {
            this.customer.cnpj = ''
            this.quotation.CnpjPadrao = ''
          } else {
            this.customer.cnpj = this.quotation.CnpjPadrao
          }
        } else {
          this.cnpjInfo = ''
          this.quotation.CnpjPadrao = ''
          this.customer.cnpj = ''
        }
        this.onChange()
      },
      
      onChange() {

        if (this.loading)
          return

        let isRetail = undefined
        
        if (this.retail)
          isRetail = (this.retail == "S")
        this.$emit("onChange", {
          customer: this.customer,
          isRetail,
          isUpd: this.isUpdating
        })
      },
    },
  }

</script>
